import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';

export const markAsRead =  (id: number) => {
        return AxiosClientFactory
            .getInstance()
            .post(`/api/inboundSmses/${id}/markAsRead`, {});
};
